/** Controls on one line, on one baseline: a filter and its action, a field and its button, verbs. */

import type { CSSProperties, ReactNode } from "react";

import { cn } from "@/lib/cn";

import "./Toolbar.css";

export interface ToolbarProps {
  /** `between` pushes the last child to the far edge. */
  readonly align?: "start" | "between";
  /** Let the first child take the free space, so a filter fills the row and its button does not. */
  readonly fill?: boolean;
  readonly className?: string;
  readonly style?: CSSProperties;
  readonly children?: ReactNode;
}

export function Toolbar({ align = "start", fill = false, className, style, children }: ToolbarProps) {
  return (
    <div
      className={cn(
        "al-toolbar",
        `al-toolbar-${align}`,
        fill ? "al-toolbar-fill" : undefined,
        className,
      )}
      style={style}
    >
      {children}
    </div>
  );
}
